import React from 'react'
import { toast } from 'react-toastify'
import { longPoll } from '~/client/lib/longPolling'
import { useQuery, fetchQueryURL } from '~/client/hooks/cqrpc'

export function useNotifications(){
  React.useEffect(subscribe, [])
  return useQuery('notifications.getAll')
}

let longPolling = false
let subscribers = []
let lastSeenAt
function subscribe(){
  const unsubscribe = () => {
    subscribers = subscribers.filter(sub => sub !== unsubscribe)
    console.log('notifications.longPoll unsubscribe', subscribers)
    if (longPolling && subscribers.length === 0) stopPolling()
  }
  subscribers.push(unsubscribe)
  console.log('notifications.longPoll subscribe', subscribers)
  if (!longPolling) startPolling()
  return unsubscribe
}

function stopPolling(){
  console.log('stopPolling', { longPolling })
  if (longPolling) longPolling()
  longPolling = false
  lastSeenAt = undefined
}

function startPolling(){
  console.log('startPolling', { longPolling })
  if (longPolling) return
  longPolling = longPoll(
    signal => {
      return fetch(
        (lastSeenAt
          ? fetchQueryURL('notifications.getNext', { lastSeenAt })
          : fetchQueryURL('notifications.getAll')
        ),
        { signal },
      )
    },
    async res => {
      const { result: notifications } = await res.json()
      if (lastSeenAt) for (const n of notifications) {
        if (new Date(n.createdAt) > lastSeenAt) toast(n.text)
      }
      lastSeenAt = new Date(notifications[0]?.createdAt || new Date)
    }
  )
}
